import React from 'react';
import { Card, Row, Col, Image } from 'react-bootstrap';
import useWindowDimensions from '../../helpers/GetCurrentWidth';

import './styles.css';

export default function StateCard(props: any) {

  return (
    <div>
      <Card className='mt-2'>
        <Card.Body className={props.classInfo && props.classInfo.padding}>
          <Row>
            <Col xs={5} sm={5} md={4} lg={3} className="d-flex justify-content-center align-items-center">
              <div className={`circle-icon ${props.classInfo && props.classInfo.margin}`}>
                <Image src={props.stateData.stateIcon}></Image>
              </div>
            </Col>
            <Col xs={7} sm={7} md={8} lg={9}>
              <p className="card-number m-0">{props.stateData.stateNumber}</p>
              <p className="card-content m-0">{props.stateData.stateContent}</p>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </div>
  )
}